// extracted by mini-css-extract-plugin
export var container = "_7m-0";
export var icon = "_7m-1";
export var text = "_7m-2";